/** SystemHub mesajlaşma olaylarını store'a işler; bağlantı yeniden kurulunca listeyi tazeler. */
import { useEffect } from 'react';
import { eventBus } from '@/shared/realtime/eventBus';
import { useChatStore } from './chatStore';
import type { ChatMessage } from './types';

export function useChatRealtime(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return;
    const s = useChatStore.getState;
    const onMessage = (m: unknown) => s().applyMessage(m as ChatMessage);
    const onUpdated = (m: unknown) => s().applyMessage(m as ChatMessage, { updated: true });
    const onRead = (e: Parameters<ReturnType<typeof s>['applyRead']>[0]) => s().applyRead(e);
    const onTyping = (e: Parameters<ReturnType<typeof s>['applyTyping']>[0]) => s().applyTyping(e);
    const onReactions = (e: { messageId: string; reactions: { emoji: string; userIds: string[] }[] }) =>
      s().applyReactions(e.messageId, e.reactions);
    const onGroup = () => void s().loadConversations();
    const onConnection = (state: string) => {
      // Kopukluk sırasında kaçan mesajlar: liste ve açık konuşma yeniden okunur.
      if (state !== 'connected') return;
      void s().loadConversations();
      const key = s().activeKey;
      if (key) void s().loadThread(key);
    };
    eventBus.on('ChatMessage', onMessage);
    eventBus.on('ChatMessageUpdated', onUpdated);
    eventBus.on('ChatRead', onRead);
    eventBus.on('ChatTyping', onTyping);
    eventBus.on('ChatReactions', onReactions);
    eventBus.on('ChatGroupChanged', onGroup);
    eventBus.on('ConnectionState', onConnection);
    void s().loadConversations();
    return () => {
      eventBus.off('ChatMessage', onMessage);
      eventBus.off('ChatMessageUpdated', onUpdated);
      eventBus.off('ChatRead', onRead);
      eventBus.off('ChatTyping', onTyping);
      eventBus.off('ChatReactions', onReactions);
      eventBus.off('ChatGroupChanged', onGroup);
      eventBus.off('ConnectionState', onConnection);
    };
  }, [enabled]);
}
